import axios from 'axios'
import { Message } from 'element-ui'

/* 请求配置 */
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});

/* 请求前拦截 */
service.interceptors.request.use(config => {
  console.log(config)
  // config.headers.Authorization = window.sessionStorage.getItem('token')
  if (config.method === "get") {
    config.params = { ...config.params};
  } else {
    config.data = { ...config.data};
  }
  return config
}, error => {
  Message.error({ message: '请求超时!' })
  return Promise.reject(error)
})

/* 响应拦截 */
service.interceptors.response.use(
/**
   * 通过接口返回码确定返回状态
   * 还可以通过HTTP状态代码来判断请求状态
   */
  response => {
    // 响应数据
    const res = response.data
      // 返回码200：成功
      if (res.code === 200) {
        return res
      } else {
        // return Promise.reject(new Error(res.msg || 'Server error'))
        return Promise.reject(res)
      }
  },
  error => {
    // 请求取消时，不做处理
    if (!axios.isCancel(error)) {
      // 处理错误
    }
    // 响应错误
    const res = error.response.data
    if (process.env.NODE_ENV === 'development') {
      console.log(error.response)
    }
    return Promise.reject(error)
  })

export default service
